// import moment from 'moment'
import cookie from 'js-cookie'

export const getCompanyDetails = JSON.parse(window.localStorage.getItem('company'))
export const getUserDetails = JSON.parse(window.localStorage.getItem('user'))
export const getUserType = (obj) => {
  const userTypeArray = ['Analyst', 'Strategist']
  const finalValue1 = obj?.user?.OrganizationUsers?.AdminUserType || null
  const finalValue2 = (JSON.parse(window.localStorage.getItem('user')))?.OrganizationUsers?.AdminUserType
  const finalValue = finalValue1 || finalValue2
  return { name: userTypeArray[finalValue], value: finalValue }
}

export const isValidEmail = (email, type = '') => {
  if (email.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/) && type === 'msg') return 'Please provide an email address that at least looks valid. We value your privacy and wont share your email address without your explicit consent.'
  return email.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)
}

export const defaultSelectObj = {
  empty: { label: '', value: '' },
  spaced: { label: ' ', value: '' },
  all: { label: '[ALL]', value: '[ALL]' },
  blank: { label: '[Blank]', value: '[Blank]' } // NEED TO CHECK
}

export const setUserDetails = (param) => JSON.parse(window.localStorage.setItem('user', param))
export const removeUserDetails = () => {
  window.localStorage.removeItem('user')
  window.localStorage.removeItem('logs')
}

export const getOrganizationId = (companyObject) => {
  const ls_orgId = JSON.parse(window.localStorage.getItem('company'))
  const id = (companyObject?.OrganizationId) ? companyObject.OrganizationId : ls_orgId.OrganizationId
  // consoleLog('companyObject, ls_orgId ', companyObject, ls_orgId)
  // consoleLog('companyObject ', companyObject)
  return id
}

// export const getImageUrl = (type = '', fileName, extension = 'png') => {
//   const folderPath = (type === '') ? '' : `/${type}`
//   return `${process.env.REACT_APP_IMAGES_URL}${folderPath}/${fileName}.${extension}`
// }

export const setCurrency = (val) => {
  return val.toLocaleString('en-US', { currency: 'USD' })
}

// export const timeStampToDate = (str) => {
//   return moment(str).format('MMMM DD, YYYY')
// }

// export const dateDifference = (str) => {
//   return moment([]).diff(moment(str), 'days')
// }

// use in initiate project
export const isDirty = (values) => {
  return !!(values.BrandName ||
    values.CategoryName ||
    values.ProjectFrequency ||
    values.ProjectStartDate ||
    values.ProjectEndDate ||
    values.KeyQuestions ||
    values.TargetSegment ||
    values.BusinessObjective ||
    values.KeyQuestions ||
    values.CompetitorsOption !== 'NA')
}

export const getPxToInch = (px = 0) => {
  return px * 0.0104166667
}

export const removeRememberMe = () => {
  cookie.remove('userEmail')
  cookie.remove('userPassword')
}

export const rememberMe = (data) => {
  cookie.set('userEmail', data.email)
  cookie.set('userPassword', data.password)
}

export const getRememberUser = () => {
  const userName = cookie.get('userEmail')
  const password = cookie.get('userPassword')
  return ({
    userName,
    password
  })
}

export const getObjectAsArray = (data = [], type = '') => {
  // return data
  if (type === '') {
    return Array.isArray(data) ? data : [data]
  } else {
    if (Array.isArray(data)) { // its array
      return data
    } else { // its object
      if (typeof data === 'string' && data === 'undefined') { return [] }
      if (Object.keys(data).length === 0) { return [] }
    }
    return [data]
  }
}

export const convertStringToSelectArray = (array) => {
  return array.map(d => ({ label: d, value: d }))
}

export const consoleLog = (param1 = '', param2 = '', param3 = '', param4 = '') => {
  /* eslint-disable */
  console.log(param1, param2, param3, param4)
  /* eslint-enable */
}

export const trimData = (str) => {
  return (String(str)).trim().replaceAll('\n', '').replaceAll('\r', '').replaceAll('\t', '')
}

export const htmlEntitiesFunc = (str) => {
  return (String(str)).trim().replaceAll('&amp;', '&').replaceAll('&lt;', '<').replaceAll('&gt;', '>').replaceAll('&quot;', '"').replaceAll('&nbsp;', ' ')
}

export const getFormattedDateTime = (str) => {
  const dt = new Date(str)
  // 9/4/2024 9:20:05 AM
  const hours = dt.getHours() < 12 ? dt.getHours() : dt.getHours() - 12
  const mm = dt.getHours() < 12 ? 'AM' : 'PM'
  return `${dt.getMonth() + 1}/${dt.getDate()}/${dt.getFullYear()} ${hours}:${dt.getMinutes()}:${(dt.getSeconds())} ${mm}`
}

export const checkLocalStorageSize = (maxLen = 100) => {
  let _lsTotal = 0
  let _xLen
  let _x

  for (_x in localStorage) {
    if (typeof localStorage !== 'undefined' && !Object.prototype.hasOwnProperty.call(localStorage, _x)) {
      continue
    }
    // if (typeof localStorage !== 'undefined' && !localStorage.hasOwnProperty(_x)) {
    //   continue
    // }
    // if (!localStorage.hasOwnProperty(_x)) {
    //   continue
    // }
    _xLen = ((localStorage[_x].length + _x.length) * 2)
    _lsTotal += _xLen
  }
  const kb = (_lsTotal / 1024).toFixed(2)
  const mb = (kb / 1024).toFixed(2)
  if (mb > 9) {
    consoleLog('OMG -- cached cleared')
    const localStorageLogs = JSON.parse(window.localStorage.getItem('logs'))
    if (localStorageLogs.length > 10) {
      const finalLocalStorageLogs = []
      for (let i = 0; i < localStorageLogs.length; i++) {
        const drivers = ['Drivers', 'SearchDrivers', 'DriversAndSubBrands', 'DriversAndRatingImpacts'].includes(localStorageLogs[i].reqId)
        if (!(i > 10 && i < maxLen && !drivers)) {
          finalLocalStorageLogs.push(localStorageLogs[i])
        }
      }
      // window.localStorage.setItem('logssss', JSON.stringify(finalLocalStorageLogs))
      checkLocalStorageSize(200)
    }
  }
}

export const sortGridBy = (data, sortBy) => {
  return data?.sort((a, b) => a[sortBy] - b[sortBy])
}

export const validateLocalPassword = (param, type) => {
  // const userWords = (JSON.parse(decodeURIComponent(getUserDetails.userWords))).map(d => Object.keys(d)).flat(1)
  const userWords = JSON.parse(window.localStorage.getItem('user'))?.userWords?.split(',') || ''
  let passwordArray = []
  if (type === 'keywordManagement') {
    passwordArray = ['testfreak', 'rskmspoweraccess']
  } else if (type === 'questionManagement') {
    passwordArray = ['testfreak', 'rspoweraccess']
  } else if (type === 'userManagement') {
    passwordArray = ['testfreak'] // CONST_PASSWORD_USER_MANAGEMENT
  } else if (type === 'userVerification') {
    passwordArray = userWords // ['testfreak'] // CONST_PASSWORD_USER_MANAGEMENT_ACCESS
  } else if (type === 'verbatimManagement') {
    passwordArray = ['testfreak', 'uploadverbatim'] // CONST_PASSWORD1_VERBATIM || CONST_PASSWORD2_VERBATIM
  }

  return (passwordArray.includes(param))
}

export const isValidRespID = (param) => {
  return param?.split('-')?.length === 5
}

export const getDistinctValues = (myArray) => {
  return [...new Set(myArray)]
}

export const sortByKey = (array, key, direction = true) => {
  if (array?.[0]) {
    // IF THIS IS KEY IS A STRING
    if (direction) {
      // Ascending Order by `name`
      return array.sort((a, b) => String((a[key] + '')).localeCompare(String((b[key] + ''))))
    }
    // Descending Order by `name`
    return array.sort((a, b) => String((b[key] + '')).localeCompare(String((a[key] + ''))))
  }
  return array
}
